export async function processQRPayment(qrId) {
	const resp = await fetch('/getQRStatus', {
		method: 'post',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ qrId }),
		credentials: 'include'
	});
	const res = await resp.json();
	const { status, errorMessage, data } = res

	return {
		data,
		status,
		errorMessage
	}
};
